import { ClockIcon, MapPinIcon, MessageSquareIcon, PhoneIcon } from 'lucide-react';
import { business, routes, specialsCopy } from '../data/site';
import { SiteLink } from './SiteLink';
type SpecialsVisitProps = {
  onOpenTextDialog: () => void;
};
export function SpecialsVisit({
  onOpenTextDialog
}: SpecialsVisitProps) {
  return <section aria-labelledby="specials-heading" className="w-full bg-white" data-id="element-491" data-mp="24bbs4p6oj79b">
      <div className="mx-auto max-w-container px-5 py-12 sm:px-8 lg:py-16" data-id="element-492" data-mp="2s1ze2edfjxev">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-493" data-mp="2s420ypjadafd">
          <div data-id="element-494" data-mp="2x094ycs4gbuo">
            <p className="text-[14px] font-bold uppercase text-pegasus-magenta" data-id="element-495" data-mp="2x2vcicf0ircw">
              {specialsCopy.eyebrow}
            </p>
            <h2 id="specials-heading" className="mt-2 text-h2-mobile font-semibold text-ink lg:text-h2-desktop" data-id="element-496" data-mp="2nahadik0viq7">
              {specialsCopy.heading}
            </h2>
            <p className="mt-4 text-body text-ink/80 sm:text-body-lg" data-id="element-497" data-mp="3frjx0x9l2uo5">{specialsCopy.body}</p>
            <div className="mt-6 flex flex-wrap items-center gap-3" data-id="element-498" data-mp="3o2lsikov5hh6">
              <SiteLink to={routes.specials} className="inline-flex min-h-[48px] items-center rounded-btn bg-pegasus-magenta px-6 text-[16px] font-bold text-white transition-colors duration-150 ease-out hover:bg-[#bb2f83]" data-id="element-499" data-mp="3o0sgepvhe51s">
                View Current Specials
              </SiteLink>
              <button type="button" onClick={onOpenTextDialog} className="inline-flex min-h-[48px] items-center gap-2 rounded-btn border border-ink/25 px-5 text-[16px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-500" data-mp="anfp5l3nuyxj">
                <MessageSquareIcon className="h-4 w-4" aria-hidden="true" data-id="element-501" data-mp="fod4lpxadevc" />
                Get Occasional Specials by Text
              </button>
            </div>
          </div>

          <div className="border-t border-ink/10 pt-8 lg:border-l lg:border-t-0 lg:pl-14 lg:pt-0" data-id="element-502" data-mp="2hf82qoeytq58">
            <p className="text-[14px] font-bold uppercase text-pine" data-id="element-503" data-mp="373c4rp49s2nz">Visit Us</p>
            <h2 className="mt-2 text-h2-mobile font-semibold text-ink lg:text-h2-desktop" data-id="element-504" data-mp="3b4flsey204qs">
              Showroom in Brooklyn, Michigan
            </h2>

            <div className="mt-5 aspect-[3/2] w-full overflow-hidden rounded-card border border-ink/10" data-id="element-505" data-mp="3g1xjtaaj8zk0">
              <iframe title="Map showing Pegasus Spas at 171 South Main Street in Brooklyn, Michigan" src="https://www.google.com/maps?q=171+South+Main+St,+Brooklyn,+MI+49230&output=embed" loading="lazy" className="h-full w-full border-0" data-id="element-506" data-mp="3l46f4davodpa" />
            </div>

            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-507" data-mp="7np8df056pf2">
              <div className="flex items-start gap-2.5" data-id="element-508" data-mp="7ptbvvu4pmet">
                <MapPinIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-509" data-mp="cnl5cuaf9gl4" />
                <address className="text-[16px] not-italic leading-6 text-ink" data-id="element-510" data-mp="hmy0e2bg5tys">
                  {business.street}
                  <br data-id="element-511" data-mp="224p3kjqur5p3" />
                  {business.cityStateZip}
                </address>
              </div>
              <div className="flex items-start gap-2.5" data-id="element-512" data-mp="1x3j5s7ic4s8p">
                <ClockIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-513" data-mp="1s57yo4jfcvu6" />
                <div className="text-[16px] leading-6 text-ink" data-id="element-514" data-mp="1n7g57634t1nv">
                  {business.hours.map(entry => <div key={entry.days} data-id="element-515" data-mp="2kt3pwtq85vjk">
                      {entry.days} {entry.time}
                    </div>)}
                </div>
              </div>
            </div>

            <p className="mt-4 flex items-center gap-2.5 text-[16px] text-ink" data-id="element-516" data-mp="2b3k8lsi5u9qt">
              <PhoneIcon className="h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-517" data-mp="26623yeb6egom" />
              <span data-id="element-518" data-mp="33lg36bif2h8h">
                Voice or text{' '}
                <a href={business.phoneHref} className="font-bold text-pegasus-blue underline decoration-pegasus-blue/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-pegasus-magenta" data-id="element-519" data-mp="33mzjg242osa9">
                  {business.phone}
                </a>
              </span>
            </p>

            <div className="mt-6 flex flex-wrap gap-3" data-id="element-520" data-mp="29ese0hygnxmf">
              <SiteLink to={routes.location} className="inline-flex min-h-[48px] items-center rounded-btn bg-pegasus-blue px-5 text-[16px] font-bold text-white transition-colors duration-150 ease-out hover:bg-ink" data-id="element-521" data-mp="29gd6m217t6hn">
                Get Directions
              </SiteLink>
              <SiteLink to={routes.contact} className="inline-flex min-h-[48px] items-center rounded-btn border border-ink/25 px-5 text-[16px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-water" data-id="element-522" data-mp="2sd4me1hjt3gy">
                Contact Us
              </SiteLink>
            </div>
          </div>
        </div>
      </div>
    </section>;
}